module.exports = __webpack_public_path__ + "img/drive-vil-5.6114d165.svg";